export default __webpack_public_path__ + "components/page-header/static/mountain-forecast__logo--white-f9c407466e039a9e4042df34791891d0.png";